import React from 'react';
import {FormPane} from "../../../components/FormZero/PageComponents/FormPane/FormPane";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Card,
    CardHeader, Checkbox, FormControl, InputLabel,
    List,
    ListItem,
    ListItemButton, ListItemIcon,
    ListItemText, MenuItem, Select,
    TextField,
    Typography
} from "@mui/material";
import {Subject} from 'rxjs';
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Divider} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import { DataGrid, GridColumns } from '@mui/x-data-grid';
import {DAYS_OF_WEEK} from "../../CommonInfo";

// let yearsSelectOptions = [];
// for (let i = 2000; i < 2070; i++) {
//     yearsSelectOptions.push({
//         label: i.toString(),
//         value: i.toString()
//     });
// }
//
// let weeksSelectOptions = [];
// for (let i = 1; i < 53; i++) {
//     weeksSelectOptions.push({
//         label: i.toString(),
//         value: i.toString()
//     });
// }

function SpeciesPicklistDialog(props: { filteredLoads: any; }) {
    const {filteredLoads} = props;

    const [filterValue, setFilterValue] = React.useState("");
    const calculateSpeciesList = (filteredLoads: any[] | null | undefined) => {
        if (filteredLoads === undefined || filteredLoads === null) return [];
        let species: { MaterialDescription: any; OrderdQty: any; }[] = [];
        filteredLoads.forEach((delivery: { items: any[]; }) => {
            // load.deliveries.forEach((delivery) => {
                delivery.items.forEach((item: { MaterialDescription: any; OrderdQty: any; }) => {
                    species.push({MaterialDescription: item.MaterialDescription, OrderdQty: item.OrderdQty})
                });
            // });
        });
        return species;
    };
    const [speciesList, setSpeciesList] = React.useState<any>(calculateSpeciesList(filteredLoads));
    const [activatedLoads, setActivatedLoads] = React.useState<any>([]);
    React.useEffect(() => {
        console.log(filteredLoads);
        setSpeciesList(calculateSpeciesList(filteredLoads));
    }, [filteredLoads]);

    const [isOpen, setOpen] = React.useState(false);

    return (<>
        <Button fullWidth={true} variant={'contained'} color={"primary"} onClick={() => setOpen(true)}>Species
            Picklist</Button>
        <Dialog
            open={isOpen}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth={"xl"}
        >
            <DialogTitle id="alert-dialog-title">
                Species Picklist
            </DialogTitle>
            <DialogContent style={{height: '400px', textAlign: 'center'}}>
                <DialogContentText id="alert-dialog-description">
                    Have ability to search list of species, and than add them to the ones you are about to print.
                </DialogContentText>
                <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                    <div style={{display: 'flex', flexDirection: 'row', gap: '1rem'}}>
                        {/*<pre>{JSON.stringify(speciesList, undefined, 4)}</pre>*/}
                        <Card variant="outlined" style={{flexGrow: 1}} elevation={1}>
                            <CardHeader sx={{px: 2, py: 1}} title={"Available"}/>
                            <div style={{padding: '0.5rem'}}>
                                <TextField size={"small"} fullWidth={true} label={"Filter"} value={filterValue}
                                           onChange={(e) => setFilterValue(e.target.value)}/>
                            </div>
                            <Divider/>
                            <List sx={{width: 300, height: 230, bgcolor: 'background.paper', overflow: 'auto',}} dense
                                  component="div" role="list">
                                {speciesList.filter((s : any) => activatedLoads.indexOf(s) === -1).filter((s : any) => {
                                    if (filterValue !== "") {
                                        // filter it
                                        return s.MaterialDescription.toLowerCase().indexOf(filterValue.toLowerCase()) > -1;
                                    } else {
                                        return true;
                                    }
                                }).map((value : any) => {
                                    const labelId = `transfer-list-all-item-${value}-label`;
                                    return (
                                        <ListItem
                                            key={value.id}
                                            role="listitem"
                                        >
                                            <ListItemText id={labelId} primary={`${value.MaterialDescription}`}/>&nbsp;
                                            <Button variant={'contained'} color={"secondary"}
                                                    onClick={() => {
                                                        // removeUserFromGroup(value.id).then()
                                                        setActivatedLoads((l: any) => [...l, value]);
                                                    }}>
                                                <FontAwesomeIcon icon={faArrowRight}/>
                                            </Button>
                                        </ListItem>
                                    );
                                })}
                                <ListItem/>
                            </List>
                        </Card>

                        <Card variant="outlined" style={{flexGrow: 1}} elevation={1}>
                            <CardHeader sx={{px: 2, py: 1}} title={"Selected For Print"}/>
                            <Divider/>
                            <List sx={{width: 300, height: 230, bgcolor: 'background.paper', overflow: 'auto',}} dense
                                  component="div" role="list">
                                {speciesList.filter((s: any) => activatedLoads.indexOf(s) > -1).map((value: { id: React.Key | null | undefined; MaterialDescription: any; }) => {
                                    const labelId = `transfer-list-all-item-${value}-label`;
                                    return (
                                        <ListItem
                                            key={value.id}
                                            role="listitem"
                                        >
                                            <Button variant={'contained'} color={"error"}
                                                    onClick={() => {
                                                        // addUserToGroup(value.id).then()
                                                        setActivatedLoads((l: any[]) => l.filter((s: any) => s !== value));
                                                    }}>
                                                <FontAwesomeIcon icon={faArrowLeft}/>
                                            </Button>&nbsp;<ListItemText style={{textAlign: "right"}}
                                                                         id={labelId}
                                                                         primary={`${value.MaterialDescription}`}/>
                                        </ListItem>
                                    );
                                })}
                                <ListItem/>
                            </List>
                        </Card>
                    </div>
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Close</Button>
                <Button onClick={() => setOpen(false)}>Print</Button>
            </DialogActions>
        </Dialog>
    </>)
}

function LoadPicklistDialog(props: { filteredLoads: any; }) {
    const {filteredLoads} = props;

    const [isOpen, setOpen] = React.useState(false);

    const [checked, setChecked] = React.useState<any>([]);
    const handleToggle = (value: any) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    return (<>
        <Button fullWidth={true} variant={'contained'} color={"primary"} onClick={() => setOpen(true)}>Shipment Picklist</Button>
        <Dialog
            open={isOpen}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Shipment Picklist
            </DialogTitle>
            <DialogContent style={{width: '450px', textAlign: 'center'}}>
                <List sx={{width: 400, height: 430, bgcolor: 'background.paper', overflow: 'auto',}} dense
                      component="div" role="list">
                    {filteredLoads.map((value: { id: React.Key | null | undefined; ShipToName: any; BrokerDeliveryID: any; }) => {
                        const labelId = `transfer-list-all-item-${value}-label`;
                        return (
                            // <pre>{JSON.stringify(value)}</pre>
                            <ListItem
                                key={value.id}
                                role="listitem"

                            >
                                <ListItemButton role={undefined} onClick={handleToggle(value)} dense>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={checked.indexOf(value) !== -1}
                                            tabIndex={-1}
                                            disableRipple
                                            // inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText id={labelId} primary={`${value.ShipToName}`} secondary={`${value.BrokerDeliveryID}`}/>
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                    <ListItem/>
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Close</Button>
                <Button onClick={() => setOpen(false)}>Print</Button>
            </DialogActions>
        </Dialog>
    </>)
}

function AssignToDayColumn(props: { cellValues: any; updateUI: any; }) {
    const {cellValues, updateUI} = props;

    const [open, setOpen] = React.useState(false);
    const [day, setDay] = React.useState("");
    const updateDay = async function() {
        try {
            await axios.patch(`${process.env.REACT_APP_ENDPOINT}/api/DeliveryHeader/${cellValues.row.id}`, {
                field: 'boxShipDay',
                value: Date.parse(day)
            });
            await updateUI();
            setOpen(false);
        }
        catch (e) {
            console.log(e);
            // setResult(e);
        }
    };

    return (<>
        <Button color={"secondary"} variant={"contained"} fullWidth={true} onClick={() => setOpen(true)} >Assign Day</Button>
        {(open) && (
            <Dialog
                open={true}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{textAlign: "center"}}>
                    Choose Day Of Week
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {/*Please select the day of the week. <br />*/}
                        Customer Name: {cellValues.row.ShipToName}<br />
                        Delivery Number: {cellValues.row.BrokerDeliveryID}
                    </DialogContentText>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Day</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={day}
                            label="Day"
                            onChange={(e) => setDay(e.target.value)}
                        >
                            {DAYS_OF_WEEK.map((d,index) => {
                                return (<MenuItem value={index}>{d}</MenuItem>)
                            })}
                            {/*<MenuItem value={10}>Ten</MenuItem>*/}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={() => {
                        // setOpen(false)
                        updateDay().then();
                    }}>Set Day</Button>
                </DialogActions>
            </Dialog>

        )}
    </>);
}

function UnassignedAccordion(props: { expanded: any; setExpanded: any; history: any; deliveries: any; updateUI: any; }) {
    const {expanded, setExpanded, history, deliveries, updateUI} = props;

    const columns : GridColumns<any> = [
        {field: 'BrokerDeliveryID', headerName: 'Delivery #', width: 150},
        {field: 'ShipToName', headerName: 'Ship To Name', width: 250},
        {field: 'ShipToAddress1', headerName: 'Ship To Address', width: 250, valueGetter: (cellValues: { row: { ShipToAddress1: string; ShipToAddress2: string; }; }) => cellValues.row.ShipToAddress1 + " " + cellValues.row.ShipToAddress2},
        // {field: 'ShipToAddress2', headerName: 'ID', width: 150},
        {field: 'ShipToCity', headerName: 'City', width: 150},
        {field: 'ShipToState', headerName: 'State', width: 150},
        {field: 'ShipToZip', headerName: 'Zip', width: 150},
        // {field: 'ShipToZip', headerName: 'ID', width: 150},
        {field: 'item_count', headerName: 'ItemCount', width: 150, valueGetter: (cellValues: { row: { items: string | any[]; }; }) => cellValues.row.items.length},
        // {field: 'id', headerName: 'ID', width: 150},
        {field: 'assign_day', headerName: ' ', width: 150, renderCell: (cellValues: any) => (<AssignToDayColumn cellValues={cellValues} updateUI={updateUI} />)},

    ];


    return (<>
        <Accordion expanded={expanded === 'unassigned'}
                   onChange={() => setExpanded(
                       expanded === 'unassigned' ? undefined : 'unassigned'
                   )}>
            <AccordionSummary
                // expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                style={{
                    backgroundColor: ('unassigned' === expanded) ? '#83AE0D' :  '#EBEBEB',
                    color: ('unassigned' === expanded) ? 'white' : 'black'
                }}
            >
                <Typography sx={{width: '33%', flexShrink: 0}}>
                    Unassigned
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div style={{display: 'flex', flexDirection: 'row', gap: '1rem'}}>
                    {/*<SpeciesPicklistDialog filteredLoads={filteredLoads}/>*/}
                    {/*<LoadPicklistDialog filteredLoads={filteredLoads}/>*/}
                </div>
                {/*<pre>{JSON.stringify(deliveries[0] || "No Items", undefined, 4)}</pre>*/}
                {expanded === 'unassigned' && (
                    <DataGrid
                        style={{height: "500px"}}
                        rows={deliveries}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        checkboxSelection={false}
                        disableSelectionOnClick={true}
                    />
                )}
            </AccordionDetails>
        </Accordion>
    </>);
}

export function BoxOrdersPickList(props: any) {
    // const {} = props;

    let history = useNavigate();
    const filterFormStructure = [
        // {key: "week", size: {default: 3}, type: "select", label: "Week", options: weeksSelectOptions},
        { key: "week_year", type: "week-filter", size: {default: 4}, label: "Patching Week", required: true  },
        { key: "week_year_view", type: "header", size: {default: 4}, valueKey: "week_year"  },
        {key: "transit_mode", size: {default: 4}, type: "select", label: "Mode", options: [
            {label: "FedEx", value: 'FedEx'},
            {label: "UPS", value: 'UPS'},
            {label: "Palletized", value: 'Palletized'},
        ]},
    ];
    const filterFormSubject = new Subject();
    const [formFilter, setFormFilter] = React.useState<any>({});
    filterFormSubject.subscribe((n : any) => setFormFilter(n));
    const [loads, setLoads] = React.useState<any>([]);

    const loadRoutes = async () => {
        if (formFilter === undefined || formFilter === null || formFilter['week_year'] === undefined || formFilter['week_year'] === null || formFilter['week_year'] === ""){
            setLoads([]);
            return;
        }
        try {
            let outputRows: any[] = [];
            await formFilter['week_year'].forEachAsync(async (weekObj: { week: any; year: any; }) => {
                const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/DeliverHeaders/${weekObj.week}/${weekObj.year}/${formFilter['transit_mode']}`);
                if (response.status === 200) {
                    // TODO: refresh the table on the main page? or location.reload
                    console.log(response);
                    outputRows = [...outputRows, ...response.data]
                }
            });
            setLoads(outputRows);
        } catch (err) {
            console.log(err);
        }
    }

    React.useEffect(() => {
        loadRoutes().then();
    }, [formFilter['week_year'], formFilter['transit_mode']]);

    const [expanded, setExpanded] = React.useState<any>(undefined);
    const DAYS_OF_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const DAYS_OF_WEEK_INDEX: {[id: string]: number} = {
        'Monday': 1, 'Tuesday': 2, 'Wednesday':3, 'Thursday':4, 'Friday':5, 'Saturday':6, 'Sunday':0
    }


    return (
        <>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: 'calc( 100vh - 100px )',
                width: '100%',
                gap: '1rem'
            }}>
                <div style={{
                    backgroundColor: 'white',
                    height: '5rem',
                    paddingLeft: '0.5rem',
                    paddingTop: "0.25rem",
                    paddingRight: '0.5rem',
                }}>
                    <FormPane formStructure={filterFormStructure} formSubject={filterFormSubject}/>
                </div>
                <div style={{paddingLeft: '1rem', paddingRight: '1rem', flexGrow: 1, overflowY: 'scroll'}}>
                    {/*<pre>{JSON.stringify(loads, undefined, 4)}</pre>*/}
                    <UnassignedAccordion expanded={expanded} setExpanded={setExpanded} history={history} deliveries={loads.filter((load : any) => load.box_ship_day === null)} updateUI={loadRoutes} />


                    {DAYS_OF_WEEK.map((day_of_week, index) => {
                        let filteredLoads = loads.filter((load : any) => load.box_ship_day == DAYS_OF_WEEK_INDEX[day_of_week]); // TODO: can't filter on load!!!!
                        return (
                            <Accordion key={day_of_week} expanded={expanded === day_of_week}
                                       onChange={() => setExpanded(
                                           expanded === day_of_week ? undefined : day_of_week
                                       )}>
                                <AccordionSummary
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                    style={{
                                        backgroundColor: (day_of_week === expanded) ? '#83AE0D' : (index % 2 === 1) ? '#EBEBEB' : 'white',
                                        color: (day_of_week === expanded) ? 'white' : 'black'
                                    }}
                                >
                                    <Typography sx={{width: '33%', flexShrink: 0}}>
                                        {day_of_week}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div style={{display: 'flex', flexDirection: 'row', gap: '1rem'}}>
                                        <SpeciesPicklistDialog filteredLoads={filteredLoads}/>
                                        <LoadPicklistDialog filteredLoads={filteredLoads}/>
                                    </div>
                                    <List>
                                        {filteredLoads.map((load : any) => {
                                            let primaryText = `${load.BrokerDeliveryID} ${load.ShipToName}`;
                                            let secondaryText = `${load.ShipToCity}, ${load.ShipToState} ${load.ShipToZip}`;

                                            return (
                                                <ListItem disablePadding>
                                                    <ListItemButton onClick={() => {
                                                        history(`/shipping/box_order_pick_list/${load.id}`)
                                                    }}>
                                                        <ListItemText primary={primaryText} secondary={secondaryText}/>
                                                    </ListItemButton>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}
                </div>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%', padding: '1rem', gap: '1rem'}}>

                </div>
            </div>
        </>
    )
}
